import axios, { AxiosResponse } from "axios"

export const DEFAULT_API_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT ||
  "https://sanman.development.huxleymed.com/api"

export function makeAuthorizedRequest(
  url: string,
  method: "GET" | "POST" | "PUT" | "DELETE" = "GET",
  body?: any
): Promise<AxiosResponse> {
  const apiUrl = `${DEFAULT_API_ENDPOINT}/${url}`

  const reqConfig = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  }

  if (method === "POST") {
    return axios.post(apiUrl, body, reqConfig)
  }
  if (method === "PUT") {
    return axios.put(apiUrl, body, reqConfig)
  }
  if (method === "DELETE") {
    return axios.delete(apiUrl, reqConfig)
  }
  return axios.get(apiUrl, reqConfig)
}
